import React from 'react';

export const FeilmeldingComponent = (): JSX.Element => {
    return (
        <div className="c-alert c-alert--error">
            <p> Det har oppstått en feil. Prøv igjen senere </p>
        </div>
    );
};
